import React from 'react';
import { Feed, Icon, Accordion, Grid } from 'semantic-ui-react';

import ItemMessage from './ItemMessage';
import DetailsView from './DetailsView';

const icon = status => {
  let name = status === 'completed' ? 'check circle outline' : 'circle';
  let color = status === 'auto' || status === 'completed' ? 'green' : undefined;
  return <Icon name={name} color={color} />;
};

const View = ({
  indicator,
  index,
  date,
  assignee,
  content,
  claimHistoryEntryType,
  details,
  active,
  onItemClick,
  itemMessage,
  resourceId
}) => {
  const type = claimHistoryEntryType
    ? claimHistoryEntryType.split('::')[1]
    : '';
  return (
    <Feed.Event>
      <Feed.Label>{icon(indicator)}</Feed.Label>
      <Feed.Content>
        <Accordion>
          <Accordion.Title active={active} index={index} onClick={onItemClick}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={2}>
                  <Feed.Date>{date}</Feed.Date>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Feed.Summary>{assignee}</Feed.Summary>
                </Grid.Column>
                <Grid.Column width={3}>{content}</Grid.Column>
                <Grid.Column width={6}>
                  <ItemMessage
                    details={details}
                    type={type}
                  />
                </Grid.Column>
                <Grid.Column width={2}>
                  <Feed.Extra text>
                    <Icon name="dropdown" />
                    Show Details
                  </Feed.Extra>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Title>
          <Accordion.Content active={active}>
            {active && (
              <DetailsView
                details={details}
                resourceId={resourceId}
                type={type}
              />
            )}
          </Accordion.Content>
        </Accordion>
      </Feed.Content>
    </Feed.Event>
  );
};

export default View;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimHistory/HistoryItem/ItemView.js